// @ts-nocheckProductsData
import { Button, Checkbox, FlexboxGrid, InputGroup, Stack } from 'rsuite';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import { Form, useLocation, useNavigate } from 'react-router-dom';
import { Panel, Input, useToaster, Message } from 'rsuite';
import './style.css';
import Logo from './Asset 15_PNG.png';
import BackImg from './BackImg.jpg'
import { handleEncrypt, generateOTP, handleDecrypt } from '@/functions';
import { useFormik } from 'formik';
import sideImage from './login2a.png';
import sideImage2 from './login1a.png';
import { Player } from '@lottiefiles/react-lottie-player';
import ugr from '@/UGRoute';
import * as images from '../images/charts';
import Imgs from '../../src/assets/images/items/Growwiz-main-logo.png'
import userImg from '../images/username-1.png'
import passImg from '../images/pass.png'
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';
export default function Sign() {
  const [userData, setUserData] = useState(false);
  const [optSend, setOptSend] = useState({ email: false, mobile: false });
  const [fieldData, setFieldData] = useState({ emailid: '', mobileno: '' });
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idParam = handleDecrypt(searchParams.get('id'));
  const Cat_id = handleDecrypt(searchParams.get('Cat_id'));
  const Key = searchParams.get('Key');
  const [verify, setVerify] = useState(1);
  const [otps, setOtps] = useState({ emailOtp: '', mobileOtp: '' });
  const [mobileResendCooldown, setMobileResendCooldown] = useState(false);
  const [emailResendCooldown, setEmailResendCooldown] = useState(false);
  const [catalogueData, setCatalogueData] = useState();
  const key = '123456789QWERTYUIOPLKJHGFDSAZXCVBNMqwertyuioplkjhgfdsazxcvbnm';
  let TIME_LIMIT = 30;
  const [timePassed, setTimePassed] = useState(0);
  const [timeLeft, setTimeLeft] = useState(30);
  const [timerInterval, setTimerInterval] = useState(null);
  const toaster = useToaster();
  const navigate = useNavigate();
  const [sendMail, setSendMail] = useState(true);
  const [sendMobile, setSendMobile] = useState(true);
  const [companydata, setCompanydata] = useState('');
  useEffect(() => {
    fetchcompdata();
  }, []);
  const fetchcompdata = async () => {
    const response = await fetch(`${globalIP}/api/company-details?populate=*`);
    const json = await response.json();
    setCompanydata(json.data[0].attributes.Type);
  };
  useEffect(() => {
    sessionStorage.setItem('idParam', searchParams.get('id'));
    sessionStorage.setItem('Cat_id', searchParams.get('Cat_id'));
    sessionStorage.setItem('Key', Key);
  }, [idParam, Cat_id, Key]);
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${globalIP}/api/client-logins/${idParam}?populate=*`);
        sessionStorage.setItem('C-Name', response.data.data.attributes.typename);

        setUserData(response.data.data);
        if (new Date(response.data.data.attributes.Timeto) <= new Date()) {
          navigate('/time-up', { state: { isActive: false, timeOver: true } });
          return;
        }
      } catch (err) {
        console.error('Error fetching user data:', err);
      }
    };

    fetchUserData();
  }, [idParam]);
  const CheckCredentials = () => {
    toaster.push(
      <Message showIcon type="error">
        Check Credentials
      </Message>,
      { placement: 'topCenter' }
    );
  };
  useEffect(() => {
    const fetchData = async () => {
      const {
        data: { data }
      } = await axios.get(`${globalIP}/api/catalogues/${Cat_id}?populate=*`);
      setCatalogueData(data);

      if (data.attributes.Status == 'inActive') {
        navigate('/time-up', { state: { isActive: true, timeOver: false } });
        return;
      }
    };

    fetchData();
  }, []);
  const CatalogLinkStatus = async status => {
    const data = await axios.put(`${globalIP}/api/catalogues/${Cat_id}?populate=*`, {
      data: { LinkStatus: status }
    });
  };
  const CatalogStatus = async status => {
    const data = await axios.put(`${globalIP}/api/catalogues/${Cat_id}?populate=*`, {
      data: { Status: status }
    });
  };

  const handleCheckDetails = async name => {
    if (catalogueData.attributes.Status == 'Active') {
      if (new Date(userData?.attributes?.Timeto) >= new Date()) {
        if (name == 'loginemailid') {
          if (
            userData &&
            userData.attributes.loginemailid &&
            userData.attributes.loginemailid.length
          ) {
            if (fieldData.emailid) {
              userData.attributes.loginemailid.forEach(data => {
                if (data.emailid == fieldData.emailid) {
                  if (data.emailsts) {
                    setOptSend(prev => ({ ...prev, email: true }));
                    const otp = generateOTP(4, key);
                    sendEmail(fieldData.emailid, otp);
                    setSendMail(false);
                    setOtps(prev => ({ ...prev, emailOtp: otp }));
                  } else {
                    toaster.push(
                      <Message showIcon type="error">
                        This Email is blocked: {fieldData.emailid}. You don't access
                      </Message>,
                      { placement: 'topCenter' }
                    );
                    setVerify(prev => prev + 1);
                  }
                }
              });
            } else {
              toaster.push(
                <Message showIcon type="error">
                  Enter Gmail
                </Message>,
                { placement: 'topCenter' }
              );
              // CatalogStatus('inActive');
            }
          }
        } else if (name == 'loginmobile') {
          if (
            userData &&
            userData.attributes.loginmobile &&
            userData.attributes.loginmobile.length
          ) {
            if (fieldData.mobileno) {
              userData.attributes.loginmobile.forEach(data => {
                if (data.mobileno == fieldData.mobileno) {
                  if (data.mobilests) {
                    toaster.push(
                      <Message showIcon type="success">
                        OTP Sent on this number: {fieldData.mobileno}
                      </Message>,
                      { placement: 'topCenter' }
                    );
                    setOptSend(prev => ({ ...prev, mobile: true }));
                    const otp = generateOTP(4, key);
                    setOtps(prev => ({ ...prev, mobileOtp: otp }));
                    setSendMobile(false);
                    setMobileResendCooldown(true);
                    setTimeout(() => {
                      setMobileResendCooldown(false);
                    }, 30000);
                  } else {
                    toaster.push(
                      <Message showIcon type="error">
                        This Mobile number is blocked: {fieldData.emailid}. You don't access
                      </Message>,
                      { placement: 'topCenter' }
                    );
                    setVerify(prev => prev + 1);
                  }
                }
              });
            } else {
              toaster.push(
                <Message showIcon type="error">
                  Enter Mobile number
                </Message>,
                { placement: 'topCenter' }
              );
            }
          }
        }
      } else {
        toaster.push(
          <Message showIcon type="error">
            Your link is Expired
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } else {
      toaster.push(
        <Message showIcon type="error">
          Your link is not Active
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };
  const [visible, setVisible] = React.useState(false);
  const handleChangeVisibility = () => {
    setVisible(!visible);
  };
  const resendOtp = value => {
    if (catalogueData.attributes.Status == 'Active') {
      if (new Date(userData?.attributes?.Timeto) >= new Date()) {
        if (value === 'mobile' && !mobileResendCooldown) {
          const otp = generateOTP(4, fieldData.mobileno);
          setOtps(prev => ({ ...prev, mobileOtp: otp }));
          setMobileResendCooldown(true);
          setOptSend(prev => ({ ...prev, mobile: true }));
          setSeconds(30);
          setTimeLeft(30);
          setTimerInterval(null);
          setTimePassed(0);
          setTimeout(() => {
            setMobileResendCooldown(false);
          }, 30000); // 30 sec
        } else if (value === 'email' && !emailResendCooldown) {
          const otp = generateOTP(4, key);
          sendEmail(fieldData.emailid, otp);
          setOtps(prev => ({ ...prev, emailOtp: otp }));
          setOptSend(prev => ({ ...prev, email: true }));
          setSeconds(30);
          setTimeLeft(30);
          setTimerInterval(null);
          setTimePassed(0);
          setEmailResendCooldown(true);
          setTimeout(() => {
            setEmailResendCooldown(false);
          }, 30000); // 30 sec
        }
      } else {
        toaster.push(
          <Message showIcon type="error">
            Your link is Expired
          </Message>,
          { placement: 'topCenter' }
        );
        CatalogStatus('inActive');
      }
    } else {
      toaster.push(
        <Message showIcon type="error">
          Your link is not Active
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };
  const [seconds, setSeconds] = useState(30);
  const intervalRef = useRef();
  useEffect(() => {
    if (emailResendCooldown) {
      intervalRef.current = setInterval(() => {
        setSeconds(prevSeconds => {
          if (prevSeconds == 0) {
            clearInterval(intervalRef.current);
            setOtps({ emailOtp: '', mobileOtp: '' });
            return 0;
          } else {
            return prevSeconds - 1;
          }
        });
      }, 1000);

      return () => clearInterval(intervalRef.current);
    }
  }, [emailResendCooldown]);
  function generateRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }
  useEffect(() => {
  const autoLogin = async () => {
    if (!userData?.attributes || !catalogueData?.attributes) return;
    const {
      byemail,
      bymobile,
      bypassword,
      emailotp,
      mobileotp,
      downloadppt,
      Timeto,
      typecode,
      client_id,
      userid
    } = userData.attributes;

    const allLoginsOff = !byemail && !bymobile && !bypassword && !emailotp && !mobileotp && !downloadppt;
    const isTimetoValid = Timeto && new Date(Timeto) >= new Date();
    const isCatalogueActive = catalogueData.attributes.Status === 'Active';

    if (allLoginsOff && isTimetoValid && isCatalogueActive) {
      CatalogLinkStatus('Opened');
      sessionStorage.setItem('typecode', typecode);
      sessionStorage.setItem('cli', client_id);
      sessionStorage.setItem('isActive', 'true');
      const encrytTypecode = handleEncrypt(typecode);
      const encrytClient_id = handleEncrypt(client_id);
      sessionStorage.setItem('E-typecode', encrytTypecode);userid
      sessionStorage.setItem('E-cli', encrytClient_id);
      sessionStorage.setItem('userid', userid);
      sessionStorage.setItem('loginTime', new Date().toString());
      navigate(`/${ugr}/client/product`);
    }
  };
  autoLogin();
}, [userData, catalogueData]);

  const formik = useFormik({
    initialValues: {},
    onSubmit: async value => {
      const storeDate = () => {
        const loginTime = new Date().toString();
        sessionStorage.setItem('loginTime', loginTime);
      };
      const { username, password, byemail, bypassword, bymobile } = userData?.attributes;
      if (catalogueData.attributes.Status == 'Active') {
        if (new Date(userData?.attributes?.Timeto) >= new Date()) {
          if (byemail && bypassword && bymobile) {
            if (
              username == value.username &&
              password == value.password &&
              otps.emailOtp == value.emailOtp &&
              otps.mobileOtp == value.mobileOtp
            ) {
              const clinteLogin = await axios.post(`${globalIP}/api/clientactivities`, {
                data: {
                  logintime: new Date(),
                  location: 'Agra',
                  timespent: '0',
                  loginemail: fieldData.emailid,
                  loginmobile: fieldData.mobileno,
                  loginusername: value.username,
                  typecode: userData?.attributes?.typecode || ''
                }
              });
              sessionStorage.setItem('main_id', clinteLogin.data.data.id);
              sessionStorage.setItem('loginemail', fieldData.emailid);
              sessionStorage.setItem('loginmobile', fieldData.mobileno);
              sessionStorage.setItem('loginusername', value.username);
              const typeCode = clinteLogin.data.data.attributes.typecode;
              const spendTime = await axios.get(
                `${globalIP}/api/clientactivities?populate=*&filters[typecode][$eq]=${typeCode}`
              );
              const totalTime = spendTime.data.data.reduce(
                (total, item) => total + Number(item.attributes.timespent) + 0,
                0
              );
              const data = await axios.put(`${globalIP}/api/client-logins/${idParam}?populate=*`, {
                data: {
                  ...userData.attributes,
                  location: clinteLogin.data.data.attributes.location,
                  logintime: clinteLogin.data.data.attributes.logintime,
                  totaltimespent: totalTime.toString(),
                  activeEmail: clinteLogin.data.data.attributes.loginemail,
                  activeUsername: clinteLogin.data.data.attributes.loginusername,
                  activeEmail: clinteLogin.data.data.attributes.loginemail
                }
              });

              CatalogLinkStatus('Opened');
              sessionStorage.setItem('isActive', 'true');
              sessionStorage.setItem('user_id', data.data.data.id);
              sessionStorage.setItem('typecode', userData.attributes.typecode);
              sessionStorage.setItem('cli', userData.attributes.client_id);
              const encrytTypecode = handleEncrypt(userData.attributes.typecode);
              const encrytClient_id = handleEncrypt(userData.attributes.client_id);
              const encrytId = handleEncrypt(clinteLogin.data.data.id);
              sessionStorage.setItem('E-typecode', encrytTypecode);
              sessionStorage.setItem('E-cli', encrytClient_id);
              sessionStorage.setItem('E-C_A_id', encrytId);
              navigate(`/${ugr}/client/product`);
              storeDate();
            } else {
              CheckCredentials();
            }
          } else if (byemail && bypassword) {
            if (
              username == value.username &&
              password == value.password &&
              otps.emailOtp == value.emailOtp
            ) {
              const clinteLogin = await axios.post(`${globalIP}/api/clientactivities`, {
                data: {
                  logintime: new Date(),
                  location: 'Agra',
                  timespent: '0',
                  loginemail: fieldData.emailid,
                  loginusername: value.username,
                  typecode: userData?.attributes?.typecode || ''
                }
              });
              sessionStorage.setItem('loginemail', fieldData.emailid);
              sessionStorage.setItem('loginusername', value.username);
              sessionStorage.setItem('main_id', clinteLogin.data.data.id);
              const typeCode = clinteLogin.data.data.attributes.typecode;
              const spendTime = await axios.get(
                `${globalIP}/api/clientactivities?populate=*&filters[typecode][$eq]=${typeCode}`
              );
              const totalTime = spendTime.data.data.reduce(
                (total, item) => total + Number(item.attributes.timespent) + 0,
                0
              );
              const data = await axios.put(`${globalIP}/api/client-logins/${idParam}?populate=*`, {
                data: {
                  ...userData.attributes,
                  location: clinteLogin.data.data.attributes.location,
                  logintime: clinteLogin.data.data.attributes.logintime,
                  totaltimespent: totalTime.toString(),
                  activeEmail: clinteLogin.data.data.attributes.loginemail,
                  activeUsername: clinteLogin.data.data.attributes.loginusername
                }
              });
              CatalogLinkStatus('Opened');
              sessionStorage.setItem('isActive', 'true');
              sessionStorage.setItem('user_id', data.data.data.id);
              sessionStorage.setItem('typecode', userData.attributes.typecode);
              sessionStorage.setItem('cli', userData.attributes.client_id);
              const encrytTypecode = handleEncrypt(userData.attributes.typecode);
              const encrytClient_id = handleEncrypt(userData.attributes.client_id);
              const encrytId = handleEncrypt(clinteLogin.data.data.id);
              sessionStorage.setItem('E-typecode', encrytTypecode);
              sessionStorage.setItem('E-cli', encrytClient_id);
              sessionStorage.setItem('E-C_A_id', encrytId);
              navigate(`/${ugr}/client/product`);
              storeDate();
            } else {
              CheckCredentials();
            }
          } else if (bypassword && bymobile) {
            if (
              username == value.username &&
              password == value.password &&
              otps.mobileOtp == value.mobileOtp
            ) {
              const clinteLogin = await axios.post(`${globalIP}/api/clientactivities`, {
                data: {
                  logintime: new Date(),
                  location: 'Agra',
                  timespent: '0',
                  loginmobile: fieldData.mobileno,
                  loginusername: value.username,
                  typecode: userData?.attributes?.typecode || ''
                }
              });
              sessionStorage.setItem('loginmobile', fieldData.mobileno);
              sessionStorage.setItem('loginusername', value.username);
              sessionStorage.setItem('main_id', clinteLogin.data.data.id);
              const typeCode = clinteLogin.data.data.attributes.typecode;
              const spendTime = await axios.get(
                `${globalIP}/api/clientactivities?populate=*&filters[typecode][$eq]=${typeCode}`
              );
              const totalTime = spendTime.data.data.reduce(
                (total, item) => total + Number(item.attributes.timespent) + 0,
                0
              );
              const data = await axios.put(`${globalIP}/api/client-logins/${idParam}?populate=*`, {
                data: {
                  ...userData.attributes,
                  location: clinteLogin.data.data.attributes.location,
                  logintime: clinteLogin.data.data.attributes.logintime,
                  totaltimespent: totalTime.toString(),
                  activemobile: clinteLogin.data.data.attributes.loginmobile,
                  activeUsername: clinteLogin.data.data.attributes.loginusername
                }
              });
              CatalogLinkStatus('Opened');
              storeDate();
              sessionStorage.setItem('isActive', 'true');
              sessionStorage.setItem('user_id', data.data.data.id);
              sessionStorage.setItem('typecode', userData.attributes.typecode);
              sessionStorage.setItem('cli', userData.attributes.client_id);
              const encrytTypecode = handleEncrypt(userData.attributes.typecode);
              const encrytClient_id = handleEncrypt(userData.attributes.client_id);
              const encrytId = handleEncrypt(clinteLogin.data.data.id);
              sessionStorage.setItem('E-typecode', encrytTypecode);
              sessionStorage.setItem('E-cli', encrytClient_id);
              sessionStorage.setItem('E-C_A_id', encrytId);
              navigate(`/${ugr}/client/product`);
            } else {
              CheckCredentials();
            }
          } else if (byemail && bymobile) {
            if (otps.mobileOtp == value.mobileOtp && otps.emailOtp == value.emailOtp) {
              const clinteLogin = await axios.post(`${globalIP}/api/clientactivities`, {
                data: {
                  logintime: new Date(),
                  location: 'Agra',
                  timespent: '0',
                  loginmobile: fieldData.mobileno,
                  loginemail: fieldData.emailid,
                  typecode: userData?.attributes?.typecode || ''
                }
              });
              sessionStorage.setItem('loginemail', fieldData.emailid);
              sessionStorage.setItem('loginmobile', fieldData.mobileno);
              sessionStorage.setItem('main_id', clinteLogin.data.data.id);
              const typeCode = clinteLogin.data.data.attributes.typecode;
              const spendTime = await axios.get(
                `${globalIP}/api/clientactivities?populate=*&filters[typecode][$eq]=${typeCode}`
              );
              const totalTime = spendTime.data.data.reduce(
                (total, item) => total + Number(item.attributes.timespent) + 0,
                0
              );
              const data = await axios.put(`${globalIP}/api/client-logins/${idParam}?populate=*`, {
                data: {
                  ...userData.attributes,
                  location: clinteLogin.data.data.attributes.location,
                  logintime: clinteLogin.data.data.attributes.logintime,
                  totaltimespent: totalTime.toString(),
                  activemobile: clinteLogin.data.data.attributes.loginmobile,
                  activeEmail: clinteLogin.data.data.attributes.loginemail
                }
              });
              CatalogLinkStatus('Opened');
              storeDate();
              sessionStorage.setItem('user_id', data.data.data.id);
              sessionStorage.setItem('isActive', 'true');
              sessionStorage.setItem('typecode', userData.attributes.typecode);
              sessionStorage.setItem('cli', userData.attributes.client_id);
              const encrytTypecode = handleEncrypt(userData.attributes.typecode);
              const encrytClient_id = handleEncrypt(userData.attributes.client_id);
              const encrytId = handleEncrypt(clinteLogin.data.data.id);
              sessionStorage.setItem('E-typecode', encrytTypecode);
              sessionStorage.setItem('E-cli', encrytClient_id);
              sessionStorage.setItem('E-C_A_id', encrytId);
              navigate(`/${ugr}/client/product`);
            } else {
              CheckCredentials();
            }
          } else if (bypassword) {
            if (username == value.username && password == value.password) {
              const clinteLogin = await axios.post(`${globalIP}/api/clientactivities`, {
                data: {
                  logintime: new Date(),
                  location: 'Agra',
                  timespent: '0',
                  loginusername: value.username,
                  typecode: userData?.attributes?.typecode || ''
                }
              });
              sessionStorage.setItem('loginusername', value.username);
              sessionStorage.setItem('main_id', clinteLogin.data.data.id);
              const typeCode = clinteLogin.data.data.attributes.typecode;
              const spendTime = await axios.get(
                `${globalIP}/api/clientactivities?populate=*&filters[typecode][$eq]=${typeCode}`
              );
              const totalTime = spendTime.data.data.reduce(
                (total, item) => total + Number(item.attributes.timespent) + 0,
                0
              );
              const data = await axios.put(`${globalIP}/api/client-logins/${idParam}?populate=*`, {
                data: {
                  ...userData.attributes,
                  location: clinteLogin.data.data.attributes.location,
                  logintime: clinteLogin.data.data.attributes.logintime,
                  totaltimespent: totalTime.toString(),
                  activeUsername: clinteLogin.data.data.attributes.loginusername
                }
              });
              CatalogLinkStatus('Opened');
              storeDate();
              const randomString = generateRandomString(50);
              sessionStorage.setItem('user_id', data.data.data.id);
              sessionStorage.setItem('isActive', 'true');
              sessionStorage.setItem('typecode', userData.attributes.typecode);
              sessionStorage.setItem('cli', userData.attributes.client_id);
              const encodedId = handleEncrypt(data.data?.data?.id);
              const encrytTypecode = handleEncrypt(userData.attributes.typecode);
              const encrytClient_id = handleEncrypt(userData.attributes.client_id);
              const encrytId = handleEncrypt(clinteLogin.data.data.id);
              sessionStorage.setItem('E-typecode', encrytTypecode);
              sessionStorage.setItem('E-cli', encrytClient_id);
              sessionStorage.setItem('E-C_A_id', encrytId);
              if (companydata == 'Domestic') {
                navigate(`/${ugr}/client/product`);
              } else {
                navigate(`/${ugr}/client/product`);
              }
            } else {
              CheckCredentials();
            }
          } else if (bymobile) {
            if (otps.mobileOtp == value.mobileOtp) {
              const clinteLogin = await axios.post(`${globalIP}/api/clientactivities`, {
                data: {
                  logintime: new Date(),
                  location: 'Agra',
                  timespent: '0',
                  loginmobile: fieldData.mobileno,
                  typecode: userData?.attributes?.typecode || ''
                }
              });
              sessionStorage.setItem('loginmobile', fieldData.mobileno);
              sessionStorage.setItem('main_id', clinteLogin.data.data.id);
              const typeCode = clinteLogin.data.data.attributes.typecode;
              const spendTime = await axios.get(
                `${globalIP}/api/clientactivities?populate=*&filters[typecode][$eq]=${typeCode}`
              );
              const totalTime = spendTime.data.data.reduce(
                (total, item) => total + Number(item.attributes.timespent) + 0,
                0
              );
              const data = await axios.put(`${globalIP}/api/client-logins/${idParam}?populate=*`, {
                data: {
                  ...userData.attributes,
                  location: clinteLogin.data.data.attributes.location,
                  logintime: clinteLogin.data.data.attributes.logintime,
                  totaltimespent: totalTime.toString(),
                  activemobile: clinteLogin.data.data.attributes.loginmobile
                }
              });
              CatalogLinkStatus('Opened');
              sessionStorage.setItem('user_id', data.data.data.id);
              sessionStorage.setItem('isActive', 'true');
              sessionStorage.setItem('typecode', userData.attributes.typecode);
              sessionStorage.setItem('cli', userData.attributes.client_id);
              storeDate();
              const encrytTypecode = handleEncrypt(userData.attributes.typecode);
              const encrytClient_id = handleEncrypt(userData.attributes.client_id);
              const encrytId = handleEncrypt(clinteLogin.data.data.id);
              sessionStorage.setItem('E-typecode', encrytTypecode);
              sessionStorage.setItem('E-cli', encrytClient_id);
              sessionStorage.setItem('E-C_A_id', encrytId);
              navigate(`/${ugr}/client/product`);
            } else {
              CheckCredentials();
            }
          } else if (byemail) {
            if (otps.emailOtp == value.emailOtp && otps?.emailOtp != '' && value?.emailOtp != '') {
              storeDate();
              const clinteLogin = await axios.post(`${globalIP}/api/clientactivities`, {
                data: {
                  logintime: new Date(),
                  location: 'Agra',
                  timespent: '0',
                  loginemail: fieldData.emailid,
                  typecode: userData?.attributes?.typecode || ''
                }
              });
              sessionStorage.setItem('loginemail', fieldData.emailid);
              sessionStorage.setItem('main_id', clinteLogin.data.data.id);
              const typeCode = clinteLogin.data.data.attributes.typecode;
              const spendTime = await axios.get(
                `${globalIP}/api/clientactivities?populate=*&filters[typecode][$eq]=${typeCode}`
              );
              const totalTime = spendTime.data.data.reduce(
                (total, item) => total + Number(item.attributes.timespent) + 0,
                0
              );
              const data = await axios.put(`${globalIP}/api/client-logins/${idParam}?populate=*`, {
                data: {
                  ...userData.attributes,
                  location: clinteLogin.data.data.attributes.location,
                  logintime: clinteLogin.data.data.attributes.logintime,
                  totaltimespent: totalTime.toString(),
                  activeEmail: clinteLogin.data.data.attributes.loginemail
                }
              });
              CatalogLinkStatus('Opened');
              sessionStorage.setItem('user_id', data.data.data.id);
              sessionStorage.setItem('typecode', userData.attributes.typecode);
              sessionStorage.setItem('cli', userData.attributes.client_id);
              const encrytTypecode = handleEncrypt(userData.attributes.typecode);
              const encrytClient_id = handleEncrypt(userData.attributes.client_id);
              const encrytId = handleEncrypt(clinteLogin.data.data.id);
              sessionStorage.setItem('E-typecode', encrytTypecode);
              sessionStorage.setItem('E-cli', encrytClient_id);
              sessionStorage.setItem('E-C_A_id', encrytId);
              navigate(`/${ugr}/client/product`);
              sessionStorage.setItem('isActive', 'true');
            } else {
              CheckCredentials();
            }
          }
        } else {
          toaster.push(
            <Message showIcon type="error">
              Your link is Expired
            </Message>,
            { placement: 'topCenter' }
          );
          CatalogStatus('inActive');
        }
      } else {
        toaster.push(
          <Message showIcon type="error">
            Your link is not Active
          </Message>,
          { placement: 'topCenter' }
        );
      }
    }
  });

  const sendEmail = async (to, message) => {
    const endpoint = `${globalIP}/api/email`;
    const tem = `
    <p>Dear User,</p>
    <p>Thank you for choosing ERP Daddy. To ensure the security of your account, we have initiated a verification process.</p>
    <p>Your One-Time Password (OTP) is: ${message}</p>
    <p>Please enter this code to complete the verification process. Note that this OTP is valid for a limited time period.</p>
    <p>If you did not initiate this request, please disregard this email.</p>
    <p>Thank you for your cooperation.</p>
    <p>Best regards,</p>
    <p>ERP Daddy Private limited</p>
  `;
    const data = {
      to: to,
      subject: 'Verification Code Request',
      html: tem
    };
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        toaster.push(
          <Message showIcon type="success">
            Email sent successfully!
          </Message>,
          { placement: 'topEnd' }
        );
        setEmailResendCooldown(true);
        setTimeout(() => {
          setEmailResendCooldown(false);
        }, 30000);
      } else {
        console.error('Failed to send email');
        toaster.push(
          <Message showIcon type="error">
            Failed to send email
          </Message>,
          { placement: 'topEnd' }
        );
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    if (emailResendCooldown) {
      const interval = setInterval(() => {
        setTimePassed(prevTimePassed => prevTimePassed + 1);
      }, 1000);

      setTimerInterval(interval);

      return () => clearInterval(interval);
    }
  }, [emailResendCooldown]);

  useEffect(() => {
    if (emailResendCooldown) {
      setTimeLeft(TIME_LIMIT - timePassed);
      setCircleDasharray();
      if (timeLeft == 0) {
        onTimesUp();
      }
    }
  }, [timePassed, timeLeft, emailResendCooldown]);

  const onTimesUp = () => {
    clearInterval(timerInterval);
  };

  const formatTime = time => {
    const minutes = Math.floor(time / 60);
    let seconds = time % 60;

    if (seconds < 10) {
      seconds = `0${seconds}`;
    }

    return `${minutes}:${seconds}`;
  };

  const setCircleDasharray = () => {
    const circleDasharray = `${(calculateTimeFraction() * 283).toFixed(0)} 283`;
    document
      .getElementById('base-timer-path-remaining')
      ?.setAttribute('stroke-dasharray', circleDasharray);
  };

  const calculateTimeFraction = () => {
    const rawTimeFraction = timeLeft / TIME_LIMIT;
    return rawTimeFraction - (1 / TIME_LIMIT) * (1 - rawTimeFraction);
  };

  if (!userData) {
    return null;
  }
  return (
    <div className="show-grid">
      <FlexboxGrid 
      // className="bg-add"
      style={{
        backgroundImage: `url(${BackImg}`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        
        height: '100vh',
        width: '100%',
      }}
      >
        {/* <FlexboxGrid.Item
          colspan={14}
          style={{
            borderRadius: '5px',
            position: 'relative',
            background: 'white'
          }}
          className="grid-1"
        >
          <div className="logo-1">
            <img src={Logo} alt="" />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              margin: 'auto',
              height: `calc(100vh - 150px)`,
              width: '100%',
              padding: '0 50px'
            }}
          >
            <Player autoplay loop src={animati} />
          </div>
        </FlexboxGrid.Item> */}
     
        <FlexboxGrid.Item
          colspan={10}
          style={{
            borderRadius: '5px',
            background: 'white'
            
          }}
          className="grid-2"
        >
             
          <div className="panel-container">
            {/* <div className="sideImage">
              <img src={sideImage} alt="" />
            </div>
            <div className="sideImage-2">
              <img src={sideImage2} alt="" />
            </div> */}
            <div className="cat-name">
              <h4 className="info2">Catalogue Name : </h4>
              <p className="info2 name">
                {userData?.attributes?.typename &&
                  userData.attributes.typename.charAt(0).toUpperCase() +
                    userData.attributes.typename.slice(1)}
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
            <img src={Imgs} style={{ width: "150px", height: "40px", marginTop: "250px" , marginLeft:'-60px'}} alt="Logo" />
            <Panel className="login-panel">
              <h4 style={{ marginBottom: '50px' }}>Welcome Back!</h4>
              <p className="info1" style={{ marginBottom: '30px' }}>
                {/* Login to continue. */}
                Please login to your account and start the adventure
              </p>
              <form onSubmit={formik.handleSubmit} autoComplete="off">
                {userData?.attributes?.bypassword ? (
                  <>
                    <div className="input-wrapperr">
                     
                      <label>
                      <img src={userImg} alt="" style={{width:'15px', height:'15px', marginBottom:'5px', marginRight:'5px'}}  />
                        Username<span className="required">*</span>
                      </label>
                      <Input
                        placeholder="Enter Username"
                        size="sm"
                        name="username"
                        onChange={value => {
                          formik.setFieldValue('username', value);
                        }}
                      />
                    </div>
                    
                    <div className="input-wrapperr">
                      <label>
                      <img src={passImg} alt="" style={{width:'17px', height:'17px', marginBottom:'5px', marginRight:'5px'}}  />
                        Password<span className="required">*</span>
                      </label>
                      <InputGroup inside >
                        <Input 
                        type={visible ? 'text' : 'password'}
                         placeholder="Enter Password"
                         size="sm"
                         name="password"
                         onChange={value => {
                           formik.setFieldValue('password', value);
                         }} 
                        />
                        <InputGroup.Button onClick={handleChangeVisibility} style={{height:"28px"}}>
                        {visible ? <EyeSlashIcon /> : <EyeIcon />}
                        </InputGroup.Button>
                      </InputGroup>
                      <Stack direction="row-reverse">
                      <Checkbox name="rememberMe">
                        <a>Remember Me</a>
                      </Checkbox>
                    </Stack>
                    </div>
                  </>
                ) : null}
                {userData?.attributes?.bymobile ? (
                  <div className="input-wrapper-2">
                    <label>
                      Mobile No.<span className="required">*</span>
                    </label>

                    <Input
                      placeholder="Enter mobile number"
                      size="sm"
                      type="number"
                      onChange={value => setFieldData(prev => ({ ...prev, mobileno: value }))}
                    />
                  </div>
                ) : null}
                {userData?.attributes?.bymobile
                  ? sendMobile && (
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                          type="button"
                          onClick={() => {
                            handleCheckDetails('loginmobile');
                          }}
                          style={{ background: 'transparent' }}
                        >
                          Send OTP
                        </button>
                      </div>
                    )
                  : null}
                {userData?.attributes?.byemail ? (
                  <div className={sendMail ? 'input-wrapper-2' : 'input-wrapper'}>
                    <label>
                      Email<span className="required">*</span>
                    </label>
                    <Input
                      placeholder="Enter email"
                      size="sm"
                      onChange={value => setFieldData(prev => ({ ...prev, emailid: value }))}
                    />
                  </div>
                ) : null}
                {userData?.attributes?.byemail
                  ? sendMail && (
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                          type="button"
                          onClick={() => {
                            handleCheckDetails('loginemailid');
                          }}
                          className="handleEmail"
                          style={{ background: 'transparent', textDecoration: 'underline' }}
                        >
                          Send OTP
                        </button>
                      </div>
                    )
                  : null}
                {optSend.mobile ? (
                  <div className="input-wrapper">
                    <label>
                      Mobile No, OTP<span className="required">*</span>
                    </label>
                    <Input
                      placeholder="Enter OTP"
                      size="sm"
                      onChange={value => {
                        formik.setFieldValue('mobileOtp', value);
                      }}
                    />
                  </div>
                ) : null}
                {optSend.mobile && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button
                      type="button"
                      onClick={() => resendOtp('mobile')}
                      disabled={mobileResendCooldown}
                      style={{ color: !mobileResendCooldown ? 'cyan' : 'grey' }}
                    >
                      Resend Otp
                    </button>
                  </div>
                )}
                {optSend.email ? (
                  <div className="input-wrapper">
                    <label>
                      Email OTP<span className="required">*</span>
                    </label>
                    <Input
                      placeholder="Enter OTP"
                      size="sm"
                      autoFocus={false}
                      aria-autocomplete="none"
                      autoComplete="off"
                      name="emailOtp"
                      onChange={value => {
                        formik.setFieldValue('emailOtp', value);
                      }}
                    />
                  </div>
                ) : null}
                {optSend.email && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {seconds < 2 ? (
                      <button
                        type="button"
                        onClick={() => resendOtp('email')}
                        disabled={emailResendCooldown}
                        style={{
                          color: !emailResendCooldown ? 'rgb(0, 92, 128)' : 'grey',
                          background: 'transparent'
                        }}
                      >
                        Resend Otp
                      </button>
                    ) : (
                      <div className="base-timer">
                        <svg
                          className="base-timer__svg"
                          viewBox="0 0 100 100"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g className="base-timer__circle">
                            <circle
                              className="base-timer__path-elapsed"
                              cx="50"
                              cy="50"
                              r="45"
                            ></circle>
                            <path
                              id="base-timer-path-remaining"
                              strokeDasharray={283}
                              className={`base-timer__path-remaining  ${
                                seconds >= 20 && seconds <= 15
                                  ? 'green'
                                  : seconds <= 10
                                  ? 'red'
                                  : seconds <= 15
                                  ? 'orange'
                                  : 'green'
                              }`}
                              d="
                  M 50, 50
                  m -45, 0
                  a 45,45 0 1,0 90,0
                  a 45,45 0 1,0 -90,0
                "
                            ></path>
                          </g>
                        </svg>
                        <span id="base-timer-label" className="base-timer__label">
                          {formatTime(timeLeft)}
                        </span>
                      </div>
                    )}
                  </div>
                )}

                <div className="input-wrapper-1">
                  <Button
                    appearance="primary"
                    color="cyan"
                    size="sm"
                    type="submit"
                    // icon={<SendIcon />}
                    disabled={verify == 1 ? false : true}
                  >
                    Login
                  </Button>
                </div>
              </form>
            </Panel>
          </div>
          </div>
        </FlexboxGrid.Item>

        <FlexboxGrid.Item
          colspan={24}
          style={{
            borderRadius: '5px',
            background: 'white'
          }}
          className="grid-3"
        >
          <div className="panel-container">
            {/* <div className="sideImage">
              <img src={sideImage} alt="" />
            </div>
            <div className="sideImage-2">
              <img src={sideImage2} alt="" />
            </div> */}
            <div className="cat-name">
              <h4 className="info2">Catalogue Name : </h4>
              <p className="info2 name">
                {userData?.attributes?.typename &&
                  userData.attributes.typename.charAt(0).toUpperCase() +
                    userData.attributes.typename.slice(1)}
              </p>
            </div>
            <Panel className="login-panel"
            >
              <h4 style={{ marginBottom: '10px' }} className="heading-welcome">
                Welcome Back!
              </h4>
              <p className="info1" style={{ marginBottom: '20px' }}>
                {/* Login to continue. */}
                Please login to your account and start the adventure
              </p>
              <form onSubmit={formik.handleSubmit} autoComplete="off">
                {userData?.attributes?.bypassword ? (
                  <>
                    <div className="input-wrapper">
                      <label>
                        Username<span className="required">*</span>
                      </label>
                      <Input
                        placeholder="Enter Username"
                        size="sm"
                        name="username"
                        onChange={value => {
                          formik.setFieldValue('username', value);
                        }}
                      />
                    </div>
                    <div className="input-wrapper">
                      <label>
                        Password<span className="required">*</span>
                      </label>
                      <Input
                        placeholder="Enter Password"
                        size="sm"
                        name="password"
                        onChange={value => {
                          formik.setFieldValue('password', value);
                        }}
                      />
                    </div>
                  </>
                ) : null}
                {userData?.attributes?.bymobile ? (
                  <div className="input-wrapper-2">
                    <label>
                      Mobile No.<span className="required">*</span>
                    </label>

                    <Input
                      placeholder="Enter mobile number"
                      size="sm"
                      type="number"
                      onChange={value => setFieldData(prev => ({ ...prev, mobileno: value }))}
                    />
                  </div>
                ) : null}
                {userData?.attributes?.bymobile
                  ? sendMobile && (
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                          type="button"
                          onClick={() => {
                            handleCheckDetails('loginmobile');
                          }}
                          style={{ background: 'transparent' }}
                        >
                          Send OTP
                        </button>
                      </div>
                    )
                  : null}
                {userData?.attributes?.byemail ? (
                  <div className={sendMail ? 'input-wrapper-2' : 'input-wrapper'}>
                    <label>
                      Email<span className="required">*</span>
                    </label>
                    <Input
                      placeholder="Enter email"
                      size="sm"
                      onChange={value => setFieldData(prev => ({ ...prev, emailid: value }))}
                    />
                  </div>
                ) : null}
                {userData?.attributes?.byemail
                  ? sendMail && (
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                          type="button"
                          onClick={() => {
                            handleCheckDetails('loginemailid');
                          }}
                          style={{ background: 'transparent' }}
                        >
                          Send OTP
                        </button>
                      </div>
                    )
                  : null}
                {optSend.mobile ? (
                  <div className="input-wrapper">
                    <label>
                      Mobile No, OTP<span className="required">*</span>
                    </label>
                    <Input
                      placeholder="Enter OTP"
                      size="sm"
                      onChange={value => {
                        formik.setFieldValue('mobileOtp', value);
                      }}
                    />
                  </div>
                ) : null}
                {optSend.mobile && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button
                      type="button"
                      onClick={() => resendOtp('mobile')}
                      disabled={mobileResendCooldown}
                      style={{ color: !mobileResendCooldown ? 'cyan' : 'grey' }}
                    >
                      Resend Otp
                    </button>
                  </div>
                )}
                {optSend.email ? (
                  <div className="input-wrapper">
                    <label>
                      Email OTP<span className="required">*</span>
                    </label>
                    <Input
                      placeholder="Enter OTP"
                      size="sm"
                      autoFocus={false}
                      aria-autocomplete="none"
                      autoComplete="off"
                      name="emailOtp"
                      onChange={value => {
                        formik.setFieldValue('emailOtp', value);
                      }}
                    />
                  </div>
                ) : null}
                {optSend.email && (
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {seconds < 2 ? (
                      <button
                        type="button"
                        onClick={() => resendOtp('email')}
                        disabled={emailResendCooldown}
                        style={{
                          color: !emailResendCooldown ? 'rgb(0, 92, 128)' : 'grey',
                          background: 'transparent'
                        }}
                      >
                        Resend Otp
                      </button>
                    ) : (
                      <div className="base-timer">
                        <svg
                          className="base-timer__svg"
                          viewBox="0 0 100 100"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g className="base-timer__circle">
                            <circle
                              className="base-timer__path-elapsed"
                              cx="50"
                              cy="50"
                              r="45"
                            ></circle>
                            <path
                              id="base-timer-path-remaining"
                              strokeDasharray={283}
                              className={`base-timer__path-remaining  ${
                                seconds >= 20 && seconds <= 15
                                  ? 'green'
                                  : seconds <= 10
                                  ? 'red'
                                  : seconds <= 15
                                  ? 'orange'
                                  : 'green'
                              }`}
                              d="
                  M 50, 50
                  m -45, 0
                  a 45,45 0 1,0 90,0
                  a 45,45 0 1,0 -90,0
                "
                            ></path>
                          </g>
                        </svg>
                        <span id="base-timer-label" className="base-timer__label">
                          {formatTime(timeLeft)}
                        </span>
                      </div>
                    )}
                  </div>
                )}

                <div className="input-wrapper-1">
                  <Button
                    appearance="primary"
                    color="cyan"
                    size="sm"
                    type="submit"
                    disabled={verify == 1 ? false : true}
                  >
                    Login
                  </Button>
                </div>
              </form>
            </Panel>

          </div>
        </FlexboxGrid.Item>
      </FlexboxGrid>
      <Stack
        className="copyright"
        justifyContent="flex-start"
        spacing={5}
        style={{
          position: 'fixed',
          bottom: '0',
          width: '-webkit-fill-available',
          textAlign: 'center',
          backgroundColor: 'white',
          paddingRight: '16px',
          marginLeft:'10px'
        }}
      >
        <p>© All Right Reserved. Product by </p>
        <p>
          {' '}
          <a href="https://erpdaddy.com/" target="_blank">
            ERPDaddy Software Solution.
          </a>
        </p>
      </Stack>
    </div>
  );
}
